import { useEffect, useMemo, useState } from 'react'
import { Modal } from 'stories/components'
import { RenderInput } from 'utils/RenderInput'

import { warehouseLineInputs } from './constants'
import { type IWarehouseLine, emptyWarehouseLine } from './types'

export const EditWarehouseLineDialog = ({
  item,
  onClose,
  onSave,
}: {
  item: Partial<IWarehouseLine> | null
  onClose: () => void
  onSave: (data: Partial<IWarehouseLine>) => Promise<void>
}) => {
  const [form, setForm] = useState<Partial<IWarehouseLine>>(emptyWarehouseLine())
  const [saving, setSaving] = useState(false)

  useEffect(() => {
    if (!item) return
    setForm({
      ...item,
      advanceRate: item.advanceRate != null ? Number(item.advanceRate) * 100 : 0,
    })
  }, [item])

  const inputs = useMemo(() => warehouseLineInputs(form), [form])

  if (!item) return null

  const onChange = (key: string, value: any) => {
    setForm((prev) => ({ ...prev, [key]: value }))
  }

  const onSubmit = async () => {
    setSaving(true)
    try {
      await onSave({
        name: form.name,
        bank: form.bank,
        glAccountNo: form.glAccountNo,
        commitment: Number(form.commitment || 0),
        advanceRate: Number(form.advanceRate || 0) / 100,
      })
      onClose()
    } finally {
      setSaving(false)
    }
  }

  return (
    <Modal
      isOpen
      title={item.id ? 'Edit Warehouse Line' : 'Add Warehouse Line'}
      loading={saving}
      disabled={!form.name?.trim()}
      onOk={onSubmit}
      onClose={onClose}
      titleOkay="Save"
      titleCancel=""
    >
      <div className="grid grid-cols-1 md:grid-cols-2 gap-4 p-2">
        {Object.keys(inputs).map((key) => (
          <RenderInput key={key} input={inputs[key]} Key={key} onChange={onChange} />
        ))}
      </div>
    </Modal>
  )
}
